import { Component, signal } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-deny-visibility.dialog',
  templateUrl: './deny-visibility.dialog.component.html',
  styleUrl: './deny-visibility.dialog.component.scss'
})
export class DenyVisibilityDialogComponent {
  maxVisibilityCount = signal(environment.maxCompareVisibilityCount ?? 3);
}
